import {
  isInformationProvidedByCustomer,
  InformationProvidedBy,
  VulnerabilityField,
} from 'modules/cm/Vulnerabilities/Vulnerability';
import * as date from 'utils/date';
import * as yup from 'yup';
import { Form } from './Vulnerability';

const schema = () =>
  yup.object().shape<Form>({
    [VulnerabilityField.Category]: yup
      .string()
      .nullable()
      .required('This field is required.'),
    [VulnerabilityField.CommentsAndAdditionalInformation]: yup
      .string()
      .nullable()
      .required('This field is required.'),
    [VulnerabilityField.InformationProvidedBy]: yup
      .string<InformationProvidedBy>()
      .nullable()
      .required('This field is required.'),
    [VulnerabilityField.IsAppropriateForExplicitConsent]: yup
      .boolean()
      .nullable()
      .when(VulnerabilityField.InformationProvidedBy, {
        is: (value: InformationProvidedBy) => isInformationProvidedByCustomer(value),
        then: yup.boolean().required('This field is required.'),
      }),
    [VulnerabilityField.IsExplicitConsentFromCustomer]: yup
      .boolean()
      .nullable()
      .when(VulnerabilityField.InformationProvidedBy, {
        is: (value: InformationProvidedBy) => isInformationProvidedByCustomer(value),
        then: yup.boolean().required('This field is required.'),
      }),
    [VulnerabilityField.DateOfConsent]: yup
      .string()
      .nullable()
      .when(VulnerabilityField.InformationProvidedBy, {
        is: (value: InformationProvidedBy) => isInformationProvidedByCustomer(value),
        then: yup
          .string()
          .nullable()
          .test('IS_DATE_VALID', 'Date is invalid.', (val) => {
            return val ? date.isValid(val, true) : true;
          }),
      }),
  });

export default schema;
